import { message } from 'antd';

import { select, call, put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects'
import { getDictationComments, createDictationCommentAPI } from '../../services/dictation-comment';

import {
    FETCH_DICTATION_COMMENTS,
    FETCH_DICTATION_COMMENTS_START,
    FETCH_DICTATION_COMMENTS_SUCCESS,
    FETCH_DICTATION_COMMENTS_ERROR,
    ADD_DICTATION_COMMENTS,
    ADD_DICTATION_COMMENTS_START,
    ADD_DICTATION_COMMENTS_SUCCESS,
    ADD_DICTATION_COMMENTS_ERROR
} from "../actions/chatActions";

function* fetchDictationComments({ reportId }) {
    try {
        yield put({ type: FETCH_DICTATION_COMMENTS_START })
        const response = yield call(getDictationComments, reportId);
        if (response.success) {
            const dictationComments = response.data.map(element => {
                const user = JSON.parse(element.user);
                return {
                    ...element,
                    user
                }
            });
            yield put({ type: FETCH_DICTATION_COMMENTS_SUCCESS, dictationComments })
        } else {
            yield put({ type: FETCH_DICTATION_COMMENTS_ERROR, message: 'Failed to fetch dictation comments!' })
        }
    } catch (error) {
        yield put({ type: FETCH_DICTATION_COMMENTS_ERROR, error })
        message.error('Failed to fetch dictation comments!');
    }
}

function* createDictationComment({ data }) {
    try {
        yield put({ type: ADD_DICTATION_COMMENTS_START })
        const response = yield call(createDictationCommentAPI, data);
        if (response) {
            const comment = {
                ...response.comment,
                user: JSON.parse(response.comment.user)
            }
            yield put({ type: ADD_DICTATION_COMMENTS_SUCCESS, comment });
        } else {
            yield put({ type: ADD_DICTATION_COMMENTS_ERROR })
        }
    } catch (error) {
        yield put({ type: ADD_DICTATION_COMMENTS_ERROR })
        message.error("Error occured while creating comment!");
    }
}


function* chatWatcher() {
    yield takeLatest(FETCH_DICTATION_COMMENTS, fetchDictationComments)
    yield takeLatest(ADD_DICTATION_COMMENTS, createDictationComment)
}

export default function* rootSaga() {
    yield all([
        chatWatcher(),
    ]);
}